import React from 'react';
import { QuoteSvg } from "../../svgs/QuoteSvg";

export type Testimonial = {
  quote: string;
  person?: string;
};

const TestimonialItem: React.FC<Testimonial> = ({ quote, person }) => (
  <div className="relative bg-white dark:bg-gray-800/60 rounded-2xl shadow-sm
    border border-gray-200/60 dark:border-gray-700/40 p-7">
    {/* Quote Icon */}
    <div className="flex justify-center">
      <div className="p-3.5 rounded-xl bg-ergo-50 dark:bg-ergo-900/60">
        <QuoteSvg classNames="w-5 h-5 fill-current text-ergo-600 dark:text-ergo-400" />
      </div>
    </div>

    {/* Quote Text */}
    <blockquote className="mt-5 text-sm text-gray-500 dark:text-gray-400 leading-relaxed text-center">
      "{quote}"
    </blockquote>

    {/* Person */}
    {person && (
      <div className="mt-5 flex items-center justify-center">
        <p className="text-xs font-medium text-gray-700 dark:text-gray-300">
          {person}
        </p>
      </div>
    )}
  </div>
);

export const TestimonialsComponent: React.FC<{ testimonials: Testimonial[] }> = ({ testimonials }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {testimonials.map((testimonial, index) => (
        <TestimonialItem key={index} {...testimonial} />
      ))}
    </div>
  );
};
